import React from "react";
import { Navigate } from "react-router-dom";
import { PropsProtectedRoute } from "../../types";

export const ProtectedRoute: React.FC<PropsProtectedRoute> = ({ authorization, children, redirectTo = "/" }) => {
  return !authorization ? <Navigate to={redirectTo} replace /> : children;
};
